import createAttachments from '../utils/createAttachments';
import getEventClientItemId from 'owa-calendar-compose-form-store/lib/utils/getEventClientItemId';
import { createAttachmentsFromFiles } from '../actions/createAttachmentsFromFiles';
import { orchestrator } from 'satcheljs';
import { lazyInsertInlineImages } from 'owa-editor-inlineimage-plugin';
import { getFullComposeViewState, setAttachmentFiles } from 'owa-calendar-compose-store-manager';
import type { AttachmentFiles } from 'owa-calendar-compose-types';

export default orchestrator(createAttachmentsFromFiles, async actionMessage => {
    let { fileList, properties, formId } = actionMessage;

    // If the event has not been created, store the attachment files
    // details in the compose store. When the event has been created
    // the onDraftEventCreated action will result in the attachments
    // being created on the event
    const eventId = getEventClientItemId(formId);

    if (properties.isInline) {
        const viewState = getFullComposeViewState(formId);
        const insertInlineImages = await lazyInsertInlineImages.import();
        fileList = await insertInlineImages(
            fileList,
            viewState.bodyViewState,
            viewState.inlineImageV2
        );
    }

    if (!eventId) {
        const attachmentFiles: AttachmentFiles = {
            fileList: fileList,
            shouldShare: properties.shouldShare,
            isInline: properties.isInline,
        };

        setAttachmentFiles(formId, attachmentFiles);
        return;
    }

    // The event has already been created so can add the
    // attachments now.
    createAttachments(fileList, properties, formId);
});
